/**
 * 半角文字を0.5文字、全角文字を1文字としてカウントする関数
 */
export const calculateDisplayLength = (str: string): number => {
  return Array.from(str).reduce((count, char) => {
    // 半角文字（ASCII文字、半角カナなど）の場合は0.5を加算
    if (char.match(/[ -~｡-ﾟ]/)) {
      return count + 0.5;
    }
    // それ以外（全角文字）は1を加算
    return count + 1;
  }, 0);
};
